// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2eUVa","name":"ConsentHeader_name__CLRSJ","birthday":"ConsentHeader_birthday__1_gZB","skeleton":"ConsentHeader_skeleton__NgcDB"};